import React from 'react'

import { styled } from 'design'

import { container } from './shared'

export const Grid = styled('div', {
  display: 'grid',
  placeItems: 'center',
  ...container,
})

export type GridProps = React.ComponentProps<typeof Grid>

Grid.displayName = 'Grid'
